import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ExpandableTextarea.css';

const MAX_HEIGHT = '4.5em';

class ExpandableTextarea extends Component {
  constructor(props) {
    super(props);

    const { value } = this.props;

    this.state = {
      height: 0,
      value
    };

    this.setValue = this.setValue.bind(this);
    this.setFilledTextareaHeight = this.setFilledTextareaHeight.bind(this);
    this.setShouldScroll = this.setShouldScroll.bind(this);
    this.setInnerRef = this.setInnerRef.bind(this);
  }

  componentDidMount() {
    this.setFilledTextareaHeight();
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;

    this.setState({
      value
    });

    this.setFilledTextareaHeight();
  }

  setInnerRef(ref) {
    this.textarea = ref;

    if (this.props.innerRef) {
      this.props.innerRef(this.textarea);
    }
  }

  setFilledTextareaHeight() {
    const element = this.shadowDiv;

    this.setState(
      {
        height: element.clientHeight
      },
      () => setTimeout(this.setShouldScroll, 500)
    );
  }

  setShouldScroll() {
    const element = this.shadowDiv;
    const textarea = this.textarea;

    if (element && textarea) {
      this.setState({
        shouldScroll: element.clientHeight > textarea.clientHeight
      });
    }
  }

  setValue(event) {
    const { value } = event.target;
    const { onChange } = this.props;

    this.setState({ value });
    onChange(event);
  }

  getExpandableField() {
    const { height, value, shouldScroll } = this.state;
    const { onKeyDown, disabled, autoFocus, placeholder } = this.props;

    return (
      <div>
        <textarea
          className="textarea"
          name="textarea"
          autoFocus={autoFocus}
          value={value}
          ref={c => this.setInnerRef(c)}
          style={{
            height,
            overflowY: shouldScroll ? 'auto' : 'hidden',
            maxHeight: MAX_HEIGHT
          }}
          onChange={this.setValue}
          onKeyUp={this.setFilledTextareaHeight}
          onKeyDown={onKeyDown}
          disabled={disabled}
          placeholder={placeholder}
        />
      </div>
    );
  }

  getShadowDiv() {
    return (
      <div
        className="textarea textarea--shadow"
        ref={c => (this.shadowDiv = c)}
        aria-hidden="true"
      >
        {this.state.value
          ? this.state.value + '\u200B'
          : this.props.placeholder}
      </div>
    );
  }

  render() {
    return (
      <div className="expandable-textarea--container">
        {this.getExpandableField()}
        {this.getShadowDiv()}
      </div>
    );
  }
}

ExpandableTextarea.propTypes = {
  maxRows: PropTypes.number,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool
};

export default ExpandableTextarea;



// WEBPACK FOOTER //
// ./src/components/ExpandableTextarea/index.js